import { UNIT_LINKS } from '../nav';
import { getLoadError } from '../store';
import { renderBnaList } from '../lever-strip';

function errorBanner(): string {
  const err = getLoadError();
  return err
    ? `<div class="load-error">Couldn't load actions: ${err}. Is the Worker running?</div>`
    : '';
}

/** A single unit's full Best Next Action list, ranked live against the current posture. */
export function renderUnitPage(slug: string): string {
  const match = UNIT_LINKS.find((u) => u.href === `#/units/${slug}`);
  const label = match?.label ?? slug;
  return `
    <div class="unit-page">
      <h2 class="unit-page__title">${label} · Best Next Actions</h2>
      ${errorBanner()}
      ${renderBnaList(slug)}
    </div>
  `;
}

/** Command center: an 8-unit tile grid, each tile showing its top actions, all re-ranking live. */
export function renderCommandCenter(): string {
  const tiles = UNIT_LINKS.map(
    (u) => {
      const slug = u.href.replace('#/units/', '');
      return `
      <div class="unit-tile">
        <a class="unit-tile__head" href="${u.href}">${u.label}</a>
        ${renderBnaList(slug, 3)}
      </div>`;
    },
  ).join('');
  return `
    <div class="command-center">
      <h2 class="command-center__title">Command Center</h2>
      <p class="command-center__sub">Set the strategic posture above — every unit's actions re-rank in real time.</p>
      ${errorBanner()}
      <div class="unit-grid">${tiles}</div>
    </div>
  `;
}
